import React from 'react'
import BlogPost from './BlogPost'

export default function EngineerToPM() {
  return (
    <BlogPost
      translationKey="engineerToPM"
      seoTitle="From Engineer to PM | Hyunjin Jae"
      seoDescription="A journey from engineering to product management, exploring the shift from code to communication and system design."
      seoKeywords="product management, engineering, career transition, communication, system design"
      seoTags={['product management', 'engineering', 'career transition', 'communication']}
    />
  )
} 